import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
export const cartContext = createContext();

export function CartContextProvider({ children }) {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const [cartData, setcartData] = useState(null);
  const [wishList, setwishList] = useState(null);
  const [cartId, setcartId] = useState(null);
  const [wishListCount, setwishListCount] = useState(null);
  const [shakeCart, setshakeCart] = useState(false);
  const [shakeWish, setshakeWish] = useState(false);

  const handleShakeCart = () => {
    setshakeCart(true);
    setTimeout(() => {
      setshakeCart(false);
    }, 600);
  };
  const handleShakeWish = () => {
    setshakeWish(true);
    setTimeout(() => {
      setshakeWish(false);
    }, 600);
  };

  let token = {
    token: localStorage.token,
  };

  //Cart (Display & Add & Remove & UpdateCount & Clear)

  async function addToCart(id) {
    try {
      let { data } = await axios.post(
        `${baseURL}/api/v1/cart`,
        {
          productId: id,
        },
        {
          headers: token,
        }
      );

      if (data.status === "success") {
        setcartData(data);
        handleShakeCart();
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function getLoggedUserCart() {
    try {
      let { data } = await axios.get(`${baseURL}/api/v1/cart`, {
        headers: {
          token: localStorage.token,
        },
      });

      if (data.status === "success") {
        setcartData(data);
        setcartId(data.data._id);
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function removeFromCart(id) {
    try {
      let { data } = await axios.delete(`${baseURL}/api/v1/cart/${id}`, {
        headers: token,
      });

      if (data.status === "success") {
        setcartData(data);
        handleShakeCart();
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function updateProductQty(id, count) {
    try {
      let { data } = await axios.put(
        `${baseURL}/api/v1/cart/${id}`,
        {
          count: count,
        },
        {
          headers: token,
        }
      );

      if (data.status === "success") {
        setcartData(data);
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function clearCart() {
    try {
      const { data } = await axios.delete(`${baseURL}/api/v1/cart`, {
        headers: token,
      });
      setcartData(null);
      return data;
    } catch (error) {
      return error;
    }
  }

  // Wish List (Display & Add & Remove)

  async function addToWishList(id) {
    try {
      let { data } = await axios.post(
        `${baseURL}/api/v1/wishlist`,
        {
          productId: id,
        },
        {
          headers: token,
        }
      );

      if (data.status === "success") {
        setwishList(data);
        handleShakeWish();
        setwishListCount(data.data.length);
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function removeFromWishList(id) {
    try {
      let { data } = await axios.delete(`${baseURL}/api/v1/wishlist/${id}`, {
        headers: token,
      });

      if (data.status === "success") {
        setwishList(data);
        handleShakeWish();
        setwishListCount(data.data.length);
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function getUserWishList() {
    try {
      let { data } = await axios.get(`${baseURL}/api/v1/wishlist`, {
        headers: {
          token: localStorage.token,
        },
      });

      if (data.status === "success") {
        setwishList(data.data);
        setwishListCount(data.data.length);
        return data;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  useEffect(() => {
    getLoggedUserCart();
    getUserWishList();
  }, []);

  return (
    <cartContext.Provider
      value={{
        cartData,
        setcartData,
        cartId,
        add: addToCart,
        get: getLoggedUserCart,
        remove: removeFromCart,
        update: updateProductQty,
        clear: clearCart,
        shakeCart,
        wishList,
        wishListCount,
        setwishList,
        addToWishList,
        removeFromWishList,
        getUserWishList,
        shakeWish,
      }}
    >
      {children}
    </cartContext.Provider>
  );
}
